import React, { useState, useEffect } from "react";
import { Card, Table, Tooltip, Button, Row, Col, message, Tag, Alert } from "antd";
import { EditFilled, FileExcelFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";
import FileDownload from "js-file-download";
import { CheckCircleOutlined } from "@material-ui/icons";
import ErrorCard from "../../../../../components/Common/Cards/ErrorCard";
import PatronagerService from "../../../../../services/Election/Patronage/PatronagerService";
import "../../../../assests/bg-colors.css";



const getRowClassName = (renderType) => {
    let className = 'whiteBg';

    switch (renderType) {
        case 'yellow':
            className = 'yellowBg';
            break;
        case 'red':
            className = 'redBg';
            break;
        case 'orange':
            className = 'orangeBg';
            break;
        default:
            className = 'whiteBg';
            break;
    }

    return className;
}



const MyPatronagersList = ({ dispatch, items, initialPagination, totalCount, isLoading, errorMessage }) => {
    const token = useSelector((state) => state.Member.token);
    const [excelLoading, setExcelLoading] = useState(false);


    const initialPaginationTable = {
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 15, 20, 25],
        pageSize: initialPagination.pageSize,
        current: initialPagination.currentPage,
        total: totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
    };


    const [paginationTable, setPaginationTable] = useState(
        initialPaginationTable
    );


    useEffect(() => {
        setPaginationTable({
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 15, 20, 25],
            pageSize: initialPagination.pageSize,
            current: initialPagination.currentPage,
            total: totalCount,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
    }, [initialPagination, totalCount]);


    const handleTableChange = (pagination, filters, sorter) => {
        setPaginationTable({
            ...pagination,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
        const action = {
            type: "set_table_pagination",
            payload: {
                pageSize: pagination.pageSize,
                currentPage: pagination.current,
            }
        };
        dispatch(action);
    };


    const tableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            align: "center",
            width: 100,
            render(text, record) {
                return {
                    children: <b>{record.row_number}.</b>,
                };
            },
        },
        {
            title: "Emri",
            dataIndex: "name",
            width: 170,
        },
        {
            title: "Mbiemri",
            dataIndex: "surname",
            width: 170,
        },
        {
            title: "QV",
            dataIndex: "qv_code",
            width: 100,
            align: "center",
        },
        {
            title: "Nr. listës",
            dataIndex: "list_number",
            width: 120,
            align: "center",
        },
        {
            title: "Kodi banesës",
            dataIndex: "building_no",
            width: 120,
            align: "center",
        },
        {
            title: "Datëlindja",
            dataIndex: "birthdate",
            width: 150,
            align: "center",
        },
        {
            title: "Mosha",
            dataIndex: "age",
            width: 100,
            align: "center",
        },
        {
            title: "VHP",
            dataIndex: "first_time",
            width: 100,
            align: "center",
            render(text, record) {
                return {
                    children:
                        <Tag className="m-0" color={record.first_time ? "purple" : "orange"}>{record.first_time ? "PO" : "JO"}</Tag>,
                };
            },
        },
        {
            title: "Preferenca",
            dataIndex: "political_preference",
            width: 150,
            align: "center",
            render(text, record) {
                return {
                    children: <b>{record.political_preference?.name}</b>
                };
            },
        },
        {
            title: "Telefoni",
            dataIndex: "phone",
            width: 170,
        },
        {
            title: "Anëtar",
            dataIndex: "is_partymember",
            width: 100,
            align: "center",
            render(text, record) {
                return {
                    children:
                        <Tag color={record.is_partymember ? "green" : "magenta"}>{record.is_partymember ? "PO" : "JO"}</Tag>,
                };
            },
        },
        {
            title: "Verifikuar",
            dataIndex: "verified",
            width: 100,
            align: "center",
            render(text, record) {
                return {
                    children:
                        record.verified && (
                            <CheckCircleOutlined style={{ color: "green" }} />
                        )
                };
            },
        },
        {
            title: "Veprime",
            dataIndex: "actions",
            className: 'm-0 p-0',
            align: "center",
            fixed: "right",
            width: 100,
            render: (_, elm) => (
                <div style={{ fontSize: "20px", backgroundColor: "#ffffff" }} className="p-2">
                    <Tooltip title="Modifiko">
                        <Button
                            type="primary"
                            onClick={() => startEditItem(elm)}
                            icon={<EditFilled />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];


    const startEditItem = (item) => {
        const action = {
            type: "open_edit_view",
            payload: {
                item: item,
                indexVisibility: 1
            }
        };
        dispatch(action);
    };


    const onExcelExport = () => {
        setExcelLoading(true);
        PatronagerService.exportMyPatronagerListToExcel(token)
            .then(response => {
                let filename = response.headers["content-disposition"].split(";");
                filename = filename[1].split("=");
                filename = filename[1];
                filename = filename.slice(1, filename.length - 1)
                message.success("Export u krye me sukses!", 1)
                    .then(FileDownload(response.data, filename));
                setExcelLoading(false);
            })
            .catch((err) => {
                const errorMessage = "Një gabim ndodhi gjatë export-imit!";
                setExcelLoading(false);
                message.error(errorMessage, 2);

            });
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>

                        {totalCount > 0 && (
                            <Row gutter={24} className="mt-2 mb-2" align="middle">
                                <Col span={12} className='text-left'>
                                    <h5 className="m-0 p-0">{parseInt(totalCount).toLocaleString() + " të patronazhuar"}</h5>
                                </Col>
                                <Col span={12} className="text-right">
                                    <Button
                                        icon={<FileExcelFilled />}
                                        type="primary"
                                        loading={excelLoading}
                                        onClick={onExcelExport}
                                    >
                                        Exporto në Excel
                                    </Button>
                                </Col>
                            </Row>
                        )}

                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card bodyStyle={{ padding: "0px" }} className={totalCount || totalCount <= 0 ? "mt-1" : "mt-4"}>
                            <div className="table-responsive">
                                <Table
                                    size="small"
                                    rowClassName={(record, index) => getRowClassName(record.voter_color)}
                                    columns={tableColumns}
                                    rowKey="id"
                                    bordered="true"
                                    dataSource={items}
                                    pagination={paginationTable}
                                    loading={isLoading}
                                    onChange={handleTableChange}
                                    locale={{ emptyText: errorMessage ? <ErrorCard message={errorMessage} /> : null }}
                                    scroll={{ x: 1800 }}
                                    showHeader="true"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>

                        {items.length > 0 && (
                            <Card style={{ borderRadius: "0" }} bodyStyle={{ padding: "15px" }} className="mt-2">
                                <h5 className="font-weight-bold">Legjendë:</h5>
                                <Row gutter={24}>
                                    <Col xl={12} lg={12} md={24} sm={24} sx={24} className="text-left mt-1">
                                        <Alert className='w-100' style={{ backgroundColor: "#ffccc7", border: "none" }} message={"Preferenca politike të kundërta!"} />
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col xl={12} lg={12} md={24} sm={24} sx={24} className="text-left mt-1">
                                        <Alert className='w-100' style={{ backgroundColor: "#ffe7ba", border: "none" }} message={"Preferenca negative por ka referencë!"} />
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col xl={12} lg={12} md={24} sm={24} sx={24} className="text-left mt-1">
                                        <Alert className='w-100' style={{ backgroundColor: "#ffffb8", border: "none" }} message={"Preferenca pa informacion por ka referencë!"} />
                                    </Col>
                                </Row>
                            </Card>
                        )}

                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default MyPatronagersList;